import React from 'react'

import * as S from './Tabs.styled'
import { TabsItem } from './TabsItem/TabsItem'
import type { Props } from './types'

export const Tabs = ({ children }: Props) => {
  return <S.Container>{children}</S.Container>
}

Tabs.Item = TabsItem
